import NBType, { InferType } from '@netbase/nb-type'

const LogoTypeInfoSchema = NBType.object().shape('LogoTypeInfoSchema', {
  /* @prop */
  displayName: NBType.string(),
  /* @prop */
  enumName: NBType.string(),
  /* @prop */
  id: NBType.number()
  /* END */
})
export default LogoTypeInfoSchema
export type LogoTypeInfo = InferType<typeof LogoTypeInfoSchema>
// RESERVE BELOW
